import { render } from "./PIMap.vue?vue&type=template&id=67195fb0"
import script from "./PIMap.vue?vue&type=script&lang=js"
export * from "./PIMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__